import { render, staticRenderFns } from "./UserEditor.vue?vue&type=template&id=42dff16a&scoped=true&"
import script from "./UserEditor.vue?vue&type=script&lang=js&"
export * from "./UserEditor.vue?vue&type=script&lang=js&"
import style0 from "./UserEditor.vue?vue&type=style&index=0&id=42dff16a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dff16a",
  null
  
)

export default component.exports